import React from 'react';

const Contact = ({ contact }) => (
  <span>
    {contact.firstName} {contact.lastName}<br />
    {contact.cellPhone ? <span>Cell: {contact.cellPhone}<br /></span> : null}
    {contact.workPhone ? <span>Work: {contact.workPhone}<br /></span> : null}
    {contact.email ? <span>Email: {contact.email}</span> : null}
  </span>
);

export default Contact;
